<script>
import { formStepperConfig } from "@/components/base/conf";
export default {
  name: "formInput",
  components: {},
  props: {
    //值
    value: {
      type: [String, Number],
      default: () => ""
    },
    //标题
    title: {
      type: String,
      default: ""
    },
    //标题宽度
    titleWidth: {
      type: String,
      default: ""
    },
    //必填
    required: {
      type: Boolean,
      default: false
    },
    //禁用
    disabled: {
      type: Boolean,
      default: false
    },
    //最小值
    min: {
      type: [String, Number],
      default: 0
    },
    //最大值
    max: {
      type: [String, Number]
    },
    //步长，每次点击时改变的值
    step: {
      type: [String, Number],
      default: 1
    },
    //输入框宽度，默认单位为px
    inputWidth: {
      type: [String, Number],
      default: formStepperConfig.inputWidth
    },
    //按钮大小以及输入框高度，默认单位为px
    buttonSize: {
      type: [String, Number],
      default: formStepperConfig.buttonSize
    },
    //固定显示的小数位数
    decimalLength: {
      type: [String, Number],
      default: formStepperConfig.decimalLength
    },
    //样式风格，可选值为 round
    theme: {
      type: [String, Number],
      default: ""
    },
    //输入框占位提示文字
    placeholder: {
      type: String,
      default: ""
    },
    //是否只允许输入整数
    integer: {
      type: Boolean,
      default: false
    },
    //是否禁用增加按钮
    disablePlus: {
      type: Boolean,
      default: false
    },
    //是否禁用减少按钮
    disableMinus: {
      type: Boolean,
      default: false
    },
    //是否禁用输入框
    disableInput: {
      type: Boolean,
      default: false
    },
    //是否禁用输入框
    asyncChange: {
      type: Boolean,
      default: false
    },
    //是否显示增加按钮
    showPlus: {
      type: Boolean,
      default: true
    },
    //是否显示减少按钮
    showMinus: {
      type: Boolean,
      default: true
    },
    //是否显示输入框
    showInput: {
      type: Boolean,
      default: true
    },
    //是否开启长按手势
    longPress: {
      type: Boolean,
      default: true
    },
    //是否允许输入的值为空
    allowEmpty: {
      type: Boolean,
      default: false
    },
    //focus时  选中所有输入值
    focusSelectAll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      realValue: this.value
    };
  },
  watch: {
    realValue(e) {
      if (this.realValue != this.value) {
        this.$emit("input", e);
      }
    },
    value(e) {
      if (this.realValue != this.value) {
        this.realValue = e;
      }
    }
  },
  methods: {
    /**
     * @description: 获取值
     * @param {*}
     * @return {*}
     */
    getValue() {
      return this.realValue;
    },
    /**
     * @description: 赋值
     * @param {*}
     * @return {*}
     */
    setValue(e) {
      this.realValue = e;
    },
    /**
     * @description: 渲染计步器
     * @param {*}
     * @return {*}
     */
    stepperRender() {
      let { disabled } = this;
      const option = {
        props: {
          disabled,
          value: this.realValue,
          label: this.title,
          labelWidth: this.titleWidth,
          required: this.required,
          min: this.min,
          max: this.max,
          step: this.step,
          inputWidth: this.inputWidth,
          buttonSize: this.buttonSize,
          decimalLength: this.decimalLength,
          theme: this.theme,
          integer: this.integer,
          disablePlus: this.disablePlus,
          disableMinus: this.disableMinus,
          disableInput: this.disableInput,
          asyncChange: this.asyncChange,
          showPlus: this.showPlus,
          showMinus: this.showMinus,
          showInput: this.showInput,
          longPress: this.longPress,
          allowEmpty: this.allowEmpty
        },
        ref: "input"
      };
      if (!disabled) {
        option.props.placeholder = this.placeholder;
        let listeners = {};
        for (const key in this.$listeners) {
          if (key != "input") {
            listeners[key] = (...arg) => {
              this.$emit(key, ...arg);
            };
          }
        }
        option.on = {
          ...listeners,
          focus: e => {
            if (this.focusSelectAll) {
              this.$refs.input.$refs.input.select();
            }
            this.$emit("submit", e);
          },
          change: e => {
            this.realValue = e;
            this.$emit("input", e);
            this.$emit("change", e);
          }
        };
      }
      return <van-stepper {...option} />;
    }
  },
  render() {
    let titleWidth = this.titleWidth;
    if (!isNaN(titleWidth)) {
      titleWidth += "px";
    }
    return (
      <div class="van-cell van-field">
        <div
          class="van-cell__title van-field__label"
          style={`width:${titleWidth}`}
        >
          <span>{this.title}</span>
        </div>
        <div class="van-cell__value van-field__value">
          <div class="van-field__body">{this.stepperRender()}</div>
        </div>
      </div>
    );
  }
};
</script>

<style lang="less" scoped>
.van-field__body {
  justify-content: end;
}
</style>
